import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Search } from 'lucide-react';

import Text from 'components/text';

interface TableStateProps {
  isLoading: boolean;
  error: unknown;
  isEmpty: boolean;
  search: string;
  onClearSearch: () => void;
  emptyMessage: string;
  errorMessage: string;
}

// Shared loading / error / empty placeholder for the Requests and Matches tables.
// Render this only when one of the three states is active; otherwise render the table.
const TableState: React.FC<TableStateProps> = ({
  isLoading,
  error,
  isEmpty,
  search,
  onClearSearch,
  emptyMessage,
  errorMessage,
}) => {
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" padding="56px 20px">
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box padding="56px 20px" textAlign="center">
        <Text fontSize={14} color="#dc2626">
          {errorMessage}
        </Text>
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={1.5}
        padding="56px 20px"
        textAlign="center"
        color="#94a3b8"
      >
        <Search size={28} style={{ opacity: 0.5 }} />
        <Text fontSize={14} color="#64748b">
          {emptyMessage}
        </Text>
        {search && (
          <Button
            variant="outlined"
            size="small"
            onClick={onClearSearch}
            sx={{ textTransform: 'none' }}
          >
            Clear search
          </Button>
        )}
      </Box>
    );
  }

  return null;
};

export default TableState;
